import React, { Dispatch } from 'react';
import Select from 'react-select';
import { FormSelectOption } from '../../components/form/FormSelect';
import { useTranslation } from 'react-i18next';
import { Site } from '../../sites/dto/Site';
import { selectCommonStyles } from '../../components/selectCommonStyles';
import { selectCommonComponents } from '../../components/selectCommonComponents';
import { useDashboardSiteSelectOptions } from '../hooks/useDashboardSiteSelectOptions';

interface Props {
  onChange: Dispatch<FormSelectOption<Site> | null>;
  placeholder?: string;
  value?: FormSelectOption<Site> | null;
  excludeSiteId?: string;
}

export function DashboardDialogsSiteSelect({ onChange, placeholder, value, excludeSiteId }: Props) {
  const { t } = useTranslation();
  const allOptions = useDashboardSiteSelectOptions();
  const options = excludeSiteId ? allOptions.filter((opt) => opt.value.id !== excludeSiteId) : allOptions;

  return (
    <Select
      options={options}
      onChange={onChange}
      value={value}
      isClearable={false}
      isRtl={process.env.REACT_APP_LANG === 'he'}
      placeholder={placeholder || t('Select site').toString()}
      components={selectCommonComponents}
      styles={selectCommonStyles}
    />
  );
}
